<template>
  <div class="login flex align-center justify-center" @touchmove.prevent   @scroll.stop.prevent>
    <div class="login-main flex-column justify-space-between">
      <div class="flex justify-end p-10">
        <img src="/images/guanbi.png" alt="" @click="onClose" class="cursor">
      </div>
      <div class="flex-column align-center justify-center mb-40">
        <div class="flex align-center mb-54"> 
          <img src="/images/zhuce.png" alt="">
          <div class="font-22 color-292a2e font-yahei mlr-10">新用户注册</div>
          <div class="bg-F9F4EE font-12 color-c19357 ml-10">已有账号，现在登录</div>
        </div>
        <div class="flex align-center w-305 border-b">
          <img src="/images/zhuce-shouji.png" alt="">
          <span class="color-292a2e font-16 ml-10">手机号</span>
          <span class="line"></span>
          <el-input v-model="user.telephone" placeholder="11位手机号码" class="flex-1" size="mini"></el-input>
        </div>
        <div class="font-12 color-ff5555 mb-28 mt-5">请填写您的手机号作为账号，方便我们为您提供设计服务</div>
        <div class="flex align-center w-305 border-b mb-28">
          <img src="/images/zhuce-mima.png" alt="">
          <span class="color-292a2e font-16 ml-10">密码</span>
          <span class="line"></span>
          <el-input v-model="user.password" placeholder="请设置密码" class="flex-1" size="mini" show-password></el-input>
        </div>
        <div class="flex align-center w-305 mb-28">
          <div class="flex align-center border-b">
            <img src="/images/zhuce-yanzhengma.png" alt="">
            <span class="color-292a2e font-16 ml-10">验证码</span>
            <span class="line"></span>
            <el-input v-model="user.code" placeholder="6位数验证码" class="flex-1" size="mini"></el-input>
          </div>
          <div class="codeBtn ml-10" @click="getCode">{{leftSeconds > 0 ? `${leftSeconds}s` : '获取'}}</div>
        </div>
        <div class="btn-40 bg-292a2e color-ff w-305 radius-round mb-28" @click="onRegister">注册</div>
        <div class="flex align-center w-305" @click="changeAgree">
          <img :src="isAgree ? '/images/xieyiyidu.png':'/images/xieyiweidu.png'" alt="">
          <div class="font-12 color-292a2e ml-10">我已阅读并同意</div>
          <div class="font-12 color-c19357">《鲁班软装服务协议》</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosx from 'axios'
export default {
  name: "Login",
  components: {},
  props:['user'],
  data () {
    return {
      isAgree: true,
      leftSeconds: 0
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    changeAgree () {
      this.isAgree = !this.isAgree
    },
    getCode () {
      if (this.leftSeconds == 0) {
        let that = this
      let params = {
        mobile: this.user.telephone,
        type: 2
      }
      if (!this.user.telephone) {
        this.$message({
            type: 'warning',
            message: '请输入手机号码!'
          })
      } else {
        this.axios.post('common/sendVerificationCode',this.qs.stringify(params)).then(res => {
				if (res.data.success) {
           this.leftSeconds = 60
          let timer = setInterval(() => {
             that.leftSeconds = that.leftSeconds - 1
              if (that.leftSeconds <= 0) {
                clearInterval(timer);
              }
            }, 1000)
				} else {
					this.$message.error(res.data.message)
				}
			})
      }
      }
    },
    onRegister () {
      if (!this.user.telephone) {
        this.$message({
            type: 'warning',
            message: '请输入手机号码!'
          })
      } else if (!this.user.password) {
        this.$message({
            type: 'warning',
            message: '请填写密码!'
          })
      } else if (!this.user.code) {
        this.$message({
            type: 'warning',
            message: '请填写验证码!'
          })
      } else if (!this.isAgree) {
        this.$message({
            type: 'warning',
            message: '请勾选服务协议!'
          })
      } else {
        let params = {
          username: this.user.username || this.user.telephone,
          telephone: this.user.telephone,
          password: this.user.password,
          verificationCode: this.user.code
        }
        this.axios.post('common/customerRegister',this.qs.stringify(params)).then(res => {
				if (res.data.success) {
          this.$message.success(res.data.message)
          this.$store.dispatch('setUser', res.data.data)
          this.$store.dispatch('setToken', res.data.data.token)
          // this.$store.dispatch('setLogin', false);
          this.$parent.isRegister = false
				} else {
					this.$message.error(res.data.message)
				}
			})
      }
    },
    onClose () {
      this.$parent.isRegister = false
    },
  }
};
</script>

<style lang="scss" scoped>
  .login{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
  }
  .login-main{
    width: 1105px;
    height: 478px;
    background: #fff url("/images/denglubg.png") no-repeat center bottom;
    border-radius: 4px;
  }
  .w-305{
    width: 305px;
  }
  .border-b{
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 6px;
  }
  .line{
    width: 1px;
    height: 18px;
    background: #e9e9e9;
    margin: 0 12px;
  }
  .shadow {
    border-radius: 30px;
    box-shadow: 0px 0px 30px 0px 
		rgba(41, 42, 46, 0.07);
  }
  ::v-deep{
    .el-input__inner{
      border: 0;
      background: transparent;
      font-size: 16px;
      padding: 0;
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus{
      border: 0;
    }
  }
  .bg-F9F4EE{
    background: #f9f4ee;
    height: 30px;
    line-height: 28px;
    padding: 0 15px;
    border-radius: 25px;
  }
  .codeBtn {
    width: 63px;
    height: 30px;
    line-height: 28PX;
    background-color: #ffffff;
    border: solid 1px #292a2e;
    border-radius: 25px;
    text-align: center;
    color: #292a2e;
    font-size: 12px;
  }
  .mb-40{
    margin-bottom: 40px;
  }
  .mt-5{
    margin-top: 5px;
  }
</style>
